/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
export class LayoutFormats {
    static A5_PORTRAIT = {
        id: 'A5_PORTRAIT',
        width: 148,
        height: 210,
        orientation: 'portrait',
    };
    static A5_LANDSCAPE = {
        id: 'A5_LANDSCAPE',
        width: 210,
        height: 148,
        orientation: 'landscape',
    };
    static A4_PORTRAIT = {
        id: 'A4_PORTRAIT',
        width: 210,
        height: 297,
        orientation: 'portrait',
    };
    static A4_LANDSCAPE = {
        id: 'A4_LANDSCAPE',
        width: 297,
        height: 210,
        orientation: 'landscape',
    };
    static A3_PORTRAIT = {
        id: 'A3_PORTRAIT',
        width: 297,
        height: 420,
        orientation: 'portrait',
    };
    static A3_LANDSCAPE = {
        id: 'A3_LANDSCAPE',
        width: 420,
        height: 297,
        orientation: 'landscape',
    };
    static A2_PORTRAIT = {
        id: 'A2_PORTRAIT',
        width: 420,
        height: 594,
        orientation: 'portrait',
    };
    static A2_LANDSCAPE = {
        id: 'A2_LANDSCAPE',
        width: 594,
        height: 420,
        orientation: 'landscape',
    };
    static All = [
        LayoutFormats.A5_PORTRAIT,
        LayoutFormats.A5_LANDSCAPE,
        LayoutFormats.A4_PORTRAIT,
        LayoutFormats.A4_LANDSCAPE,
        LayoutFormats.A3_PORTRAIT,
        LayoutFormats.A3_LANDSCAPE,
        LayoutFormats.A2_PORTRAIT,
        LayoutFormats.A2_LANDSCAPE,
    ];
}
//# sourceMappingURL=AbcLayout.js.map